/**
 * @generated SignedSource<<3a7111847de281f9281108a8a4141a95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type EditorTranslateButton_to$data = {
  readonly locale: Locale;
  readonly readOnly: boolean;
  readonly " $fragmentType": "EditorTranslateButton_to";
};
export type EditorTranslateButton_to$key = {
  readonly " $data"?: EditorTranslateButton_to$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorTranslateButton_to">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditorTranslateButton_to",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locale",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readOnly",
      "storageKey": null
    }
  ],
  "type": "Language",
  "abstractKey": null
};

(node as any).hash = "f4015abee886d5172d91d06b303ff405";

export default node;
